export default __webpack_public_path__ + "static/media/categories-collage.0df636c6.png";